import React from 'react'
import PropTypes from 'prop-types'
import { component } from '@signal/prop-types'
import renderIf from '@signal/utils/renderIf'
import mutuallyExclusiveProperties from '@signal/prop-types/mutuallyExclusiveProperties'
import { createImgixUrl } from '@signal/utils/imgix'
import ProgressiveImage from '../ProgressiveImage'
import { Wrapper, Grid, Title, Description, Icon, Image } from './styles'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import { useDarkModeContext } from '@signal/theme/Context/dark-mode'

export function DesktopEmptyScreen({
  imageUrl,
  cta,
  icon,
  iconColor,
  title,
  textColor,
  description,
  className,
  style
}) {
  const { isDarkMode } = useDarkModeContext()

  return (
    <Wrapper className={className} style={style}>
      <Grid>
        {renderIf(
          icon,
          () => (
            <Icon
              as={icon}
              width={60}
              height={60}
              alt={title}
              iconColor={iconColor}
            />
          ),
          () => (
            <ProgressiveImage src={imageUrl}>
              {(src, loading) => (
                <Image
                  imgStyle={{ objectFit: loading ? 'cover' : 'contain' }}
                  src={src}
                  alt={title}
                  $isDarkMode={isDarkMode}
                />
              )}
            </ProgressiveImage>
          )
        )}
        <Title color={textColor} style={{ opacity: isDarkMode ? 0.72 : 1 }}>
          {title}
        </Title>
        {renderIf(
          description,
          <Description
            color={textColor}
            style={{ opacity: isDarkMode ? 0.5 : 1 }}
          >
            {description}
          </Description>
        )}
        {cta}
      </Grid>
    </Wrapper>
  )
}

DesktopEmptyScreen.defaultProps = {
  imageUrl: createImgixUrl(
    'purecars-signal',
    '/empty-state/empty-state-graphic@2x.png',
    { w: 454 }
  )
}

DesktopEmptyScreen.propTypes = mutuallyExclusiveProperties(
  {
    icon: component,
    iconColor: PropTypes.string,
    imageUrl: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    cta: component
  },
  ['icon', 'imageUrl'],
  true
)

export default withCommonSnapshotsOnly(DesktopEmptyScreen)
